export enum MyRole {
  TeamManager = 'TM'
}
